import type { CircleLayer } from 'react-map-gl';

const MarkersCircleLayer: CircleLayer = {
  id: "markers-circles",
  type: "circle",
  paint: {
    "circle-radius": 8,
    "circle-color": "white"
  }
};

export { MarkersCircleLayer }
